"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.KameleonBlockComponent = void 0;
var lib_1 = require("@kameleon-core/lib");
var kameleon_block_renderer_1 = require("../helpers/kameleon-block-renderer");
var lodash_1 = require("lodash");
var lazySecondaryAndTertiary = function (secondaryBlockPackageName, tertiaryBlockPackageName, layoutProps, _secondaryBlockProps, _tertiaryBlockProps) {
    var secondaryBlockProps = (0, lodash_1.cloneDeep)(__assign({}, _secondaryBlockProps));
    var tertiaryBlockProps = (0, lodash_1.cloneDeep)(__assign({}, _tertiaryBlockProps));
    var SecondaryElement = secondaryBlockPackageName
        ? (0, kameleon_block_renderer_1.blockAsLazy)(secondaryBlockPackageName, function (_, defaultProps) {
            return (0, kameleon_block_renderer_1.ensureCorrectBlockProps)(secondaryBlockProps, defaultProps);
        })
        : null;
    var TertiaryElement = tertiaryBlockPackageName
        ? (0, kameleon_block_renderer_1.blockAsLazy)(tertiaryBlockPackageName, function (_, defaultProps) {
            return (0, kameleon_block_renderer_1.ensureCorrectBlockProps)(tertiaryBlockProps, defaultProps);
        })
        : null;
    return {
        SecondaryBlock: SecondaryElement
            ? {
                block: SecondaryElement,
                props: __assign({ layoutProps: __assign({}, layoutProps) }, (secondaryBlockProps !== null && secondaryBlockProps !== void 0 ? secondaryBlockProps : {})),
            }
            : null,
        TertiaryBlock: TertiaryElement
            ? {
                block: TertiaryElement,
                props: __assign({ layoutProps: __assign({}, layoutProps) }, (tertiaryBlockProps !== null && tertiaryBlockProps !== void 0 ? tertiaryBlockProps : {})),
            }
            : null,
    };
};
/**
 * Returns a React component containing a Lazy React function component that will load and import the requested Element
 * while rendering.
 *
 * This renderer will create a React Component for a given Kameleon Element.
 * If Secondary and/or Tertiary block package names are provided, these will be provided as props for the created React component.
 *
 * The component and its including Secondary/Tertiary block (if applicable), will be loaded using React lazy.
 *
 * Input the element (exported sections/blocks as KameleonElement) or the packageName as a string
 * - Props of the block can be given within as kameleonProps.blockProps, but will fall back to default props
 * - Props of the secondaryBlock can be given as kameleonProps.secondaryBlockProps, but will fall back to default props
 * - Props of the tertiaryBlock can be given as kameleonProps.tertiaryBlockProps, but will fall back to default props
 *
 */
var KameleonBlockComponent = function (_a) {
    var element = _a.element, kameleonProps = _a.kameleonProps, _b = _a.mergeWithDefaults, mergeWithDefaults = _b === void 0 ? false : _b;
    var _c = (0, lodash_1.cloneDeep)(kameleonProps), secondaryBlockPackageName = _c.secondaryBlockPackageName, tertiaryBlockPackageName = _c.tertiaryBlockPackageName, secondaryBlockProps = _c.secondaryBlockProps, tertiaryBlockProps = _c.tertiaryBlockProps, blockProps = _c.blockProps;
    return (0, kameleon_block_renderer_1.blockAsLazy)(element, function (loadedElement, defaultProps) {
        var _a;
        var updatedProps = __assign({}, defaultProps);
        var layoutProps = __assign(__assign({}, updatedProps === null || updatedProps === void 0 ? void 0 : updatedProps.layoutProps), blockProps === null || blockProps === void 0 ? void 0 : blockProps.layoutProps);
        updatedProps.layoutProps = layoutProps;
        if ((0, lib_1.isPrimaryBlock)(loadedElement.component)) {
            // Each primary block component has a `SecondaryBlock` and `TertiaryBlock` prop
            // set those based on the selected arg in the story controls
            var primaryBlockProps = lazySecondaryAndTertiary(secondaryBlockPackageName, tertiaryBlockPackageName, layoutProps, secondaryBlockProps, tertiaryBlockProps);
            // Now set either the primaryBlock props in case of a PrimaryCollectionBlock, or merge with args
            if ((blockProps === null || blockProps === void 0 ? void 0 : blockProps.PrimaryBlocks) || (updatedProps === null || updatedProps === void 0 ? void 0 : updatedProps.PrimaryBlocks)) {
                updatedProps.PrimaryBlocks =
                    (_a = blockProps === null || blockProps === void 0 ? void 0 : blockProps.PrimaryBlocks) !== null && _a !== void 0 ? _a : updatedProps === null || updatedProps === void 0 ? void 0 : updatedProps.PrimaryBlocks;
                // For primary collection blocks, we want to set EACH primary block entry within the `PrimaryBlocks` prop
                // to have individual secondary and tertiary props as well
                updatedProps.PrimaryBlocks = (Array.isArray(updatedProps.PrimaryBlocks)
                    ? updatedProps.PrimaryBlocks
                    : []).map(function (primaryBlock) {
                    var _a, _b, _c;
                    // So first, update each entry of the `PrimaryBlocks` props to append Secondary and/or Tertiary blocks with props
                    primaryBlock.layoutProps = layoutProps;
                    var primaryBlockItemProps = Object.assign(primaryBlock, lazySecondaryAndTertiary(secondaryBlockPackageName, tertiaryBlockPackageName, layoutProps, (_a = primaryBlock === null || primaryBlock === void 0 ? void 0 : primaryBlock.secondaryBlockProps) !== null && _a !== void 0 ? _a : undefined, (_b = primaryBlock === null || primaryBlock === void 0 ? void 0 : primaryBlock.tertiaryBlockProps) !== null && _b !== void 0 ? _b : undefined), {
                        // Second, each PrimaryBlocks entry could optionally have a "items" entry, which also "may" contain Secondary and/or Tertiary block with props
                        items: ((_c = primaryBlock.items) !== null && _c !== void 0 ? _c : []).map(function (itemProps) {
                            var _a, _b;
                            var updatedItemProps = Object.assign(itemProps, lazySecondaryAndTertiary(secondaryBlockPackageName, tertiaryBlockPackageName, layoutProps, (_a = itemProps === null || itemProps === void 0 ? void 0 : itemProps.secondaryBlockProps) !== null && _a !== void 0 ? _a : undefined, (_b = itemProps === null || itemProps === void 0 ? void 0 : itemProps.tertiaryBlockProps) !== null && _b !== void 0 ? _b : undefined));
                            delete updatedItemProps.secondaryBlockProps;
                            delete updatedItemProps.tertiaryBlockProps;
                            return updatedItemProps;
                        }),
                    });
                    delete primaryBlockItemProps.secondaryBlockProps;
                    delete primaryBlockItemProps.tertiaryBlockProps;
                    return primaryBlockItemProps;
                });
            }
            updatedProps = __assign(__assign({}, updatedProps), primaryBlockProps);
        }
        return (0, kameleon_block_renderer_1.ensureCorrectBlockProps)(blockProps, updatedProps, mergeWithDefaults === true);
    });
};
exports.KameleonBlockComponent = KameleonBlockComponent;
